import { ReactNode } from "react";
import { UserRole } from "../../../features/settings/types/settings.types";

export enum SidebarItemType {
  LINK = "link",
  GROUP = "group",
  SECTION = "section",
  ACTION = "action",
}

export interface BaseSidebarItem {
  id: string;
  label: string | ReactNode;
  type: SidebarItemType;
  roles?: UserRole[];
}

export interface SidebarLinkItem extends BaseSidebarItem {
  type: SidebarItemType.LINK;
  path: string;
  icon: ReactNode | ((active: boolean) => ReactNode);
  exact?: boolean;
  pathMatch?: string | string[];
  excludedMatch?: string | string[];
}

export interface SidebarGroupItem extends BaseSidebarItem {
  type: SidebarItemType.GROUP;
  icon: ReactNode | ((active: boolean) => ReactNode);
  children: SidebarLinkItem[];
  initialOpen?: boolean;
  pathMatch?: string | string[];
  excludedMatch?: string | string[];
}

export interface SidebarActionItem extends BaseSidebarItem {
  type: SidebarItemType.ACTION;
  icon: ReactNode | ((active: boolean) => ReactNode);
  onClick: () => void;
}

export type SidebarSectionChild = SidebarLinkItem | SidebarGroupItem | SidebarActionItem;

export interface SidebarSectionItem extends BaseSidebarItem {
  type: SidebarItemType.SECTION;
  children: SidebarSectionChild[];
}

export type SidebarItem = SidebarLinkItem | SidebarGroupItem | SidebarSectionItem | SidebarActionItem;

export interface SidebarConfig {
  items: SidebarItem[];
}
